export default "__VITE_ASSET__B0r7C4ha__"